// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#chat-message-list {
  display: flex;
  flex-direction: column-reverse;
  overflow-y: scroll;
  height: 60vh;
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
}

.message-row {
  display: grid;
  grid-template-columns: 70%;
  margin-bottom: 10px;
}

.message-content {
  display: grid;
}

.you-message {
  justify-content: end;
}

.you-message .message-content {
  justify-items: end;
}

.other-message {
  justify-items: start;
}

.other-message .message-content {
  /* grid-template-columns: 48px 1fr; */
  grid-column-gap: 15px;
}

.message-row-img {
  border-radius: 100%;
  grid-row: span 2;
  height: 50px;
}

.message-time {
  font-size: 1.2vh;
  color: #868686;
}

.message-text {
  padding: 12px 18px;
  font-size: 18px;
  line-height: 25px;
  margin-bottom: 5px;
  max-width: 45vw;
  font-weight: 400;
}



.you-message .new {
  padding: 12px 18px;
  font-size: 18px;
  line-height: 25px;
  margin-bottom: 5px;
  max-width: 45vw;
  font-weight: 400; /* Safari, Chrome and Opera > 12.1 */ /* Firefox < 16 */ /* Internet Explorer */ /* Opera < 12.1 */
 animation: fadein 1s;
  

  transform-origin:  bottom;
  background: #0E6495;
  color: #E9EEF3;
  border-radius: 16px 16px 0 16px;
}

.other-message .new {
  padding: 12px 18px;
  font-size: 18px;
  line-height: 25px;
  margin-bottom: 5px;
  max-width: 45vw;
  font-weight: 400; /* Safari, Chrome and Opera > 12.1 */ /* Firefox < 16 */ /* Internet Explorer */ /* Opera < 12.1 */
 animation: fadein 1s;
  background: #dbdbdb;
  color: #000;
  border-radius: 16px 16px 16px 0;
  overflow-wrap: normal;
  text-overflow: wrap;
}
@keyframes fadein {
    from { opacity: 0.4; }
    to   { opacity: 1; }
}

.you-message .new-img {
  padding: 12px 18px;
  font-size: 18px;
  line-height: 25px;
  margin-bottom: 5px;
  max-width: 62vw;
  font-weight: 400; /* Safari, Chrome and Opera > 12.1 */ /* Firefox < 16 */ /* Internet Explorer */ /* Opera < 12.1 */
 animation: fadein 1s;
  

  transform-origin:  bottom;
  background: #0E6495;
  color: #E9EEF3;
  border-radius: 16px 16px 0 16px;
}

.other-message .new-img {
  padding: 12px 18px;
  font-size: 18px;
  line-height: 25px;
  margin-bottom: 5px;
  max-width: 62vw;
  font-weight: 400; /* Safari, Chrome and Opera > 12.1 */ /* Firefox < 16 */ /* Internet Explorer */ /* Opera < 12.1 */
 animation: fadein 1s;
  background: #dbdbdb;
  color: #000;
  border-radius: 16px 16px 16px 0;
  overflow-wrap: normal;
  text-overflow: wrap;
}
@keyframes fadein {
    from { opacity: 0.4; }
    to   { opacity: 1; }
}

.you-message .message-text {
  background: #0E6495;
  color: #E9EEF3;
  border-radius: 16px 16px 0 16px;
}

.other-message .message-text {
  background: #dbdbdb;
  color: #000;
  border-radius: 16px 16px 16px 0;
  overflow-wrap: normal;
  text-overflow: wrap;
}

.customModal {
  background: #dbdbdb;
  max-height: 100vh;
  max-width: 100vw;
  margin: 0;
  padding: 0;
}

.closeIcon {
  fill: #eee;
  background-color: red;
  border-radius: 4px;
}

.message-text-parent {
  color: #E9EEF3;
  background: #0E6495;
  opacity:0.8;
  padding: 5px;
  border-radius: 6px;
  position: relative;
  left: -5px;
  width: 100%;
  overflow-x: hidden;
  text-overflow: ellipsis;
  display: flex;
  font-size: 15px;
  margin-bottom:3px;
}

.reply-text-left{
  background-color: aliceblue !important;
  border-top-left-radius: 7.5px;
  border-bottom-left-radius: 7.5px;
  flex: none;
  width: 100%;
  width: 4px;
  height: 25px;
  margin-right: 2px;
}

.exhibitHover:hover {
  box-shadow: 3px 3px 10px 10px rgba(0, 0, 0, 0.4);
}

.noScrollbar::-webkit-scrollbar {
  display: none !important;
}`, "",{"version":3,"sources":["webpack://./src/styles/ChatBody1.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,YAAY;EACZ,wBAAwB,GAAG,gBAAgB;EAC3C,qBAAqB,GAAG,YAAY;AACtC;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qCAAqC;EACrC,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;;;AAIA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB,EACc,oCAAoC,EACxC,iBAAiB,EACjB,sBAAsB,EACtB,iBAAiB;CACvC,oBAAoB;;;EAGxB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB,EACc,oCAAoC,EACxC,iBAAiB,EACjB,sBAAsB,EACtB,iBAAiB;CACvC,oBAAoB;EACxB,mBAAmB;EACnB,WAAW;EACX,+BAA+B;EAC/B,qBAAqB;EACrB,mBAAmB;AACrB;AACA;IACI,OAAO,YAAY,EAAE;IACrB,OAAO,UAAU,EAAE;AACvB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB,EACc,oCAAoC,EACxC,iBAAiB,EACjB,sBAAsB,EACtB,iBAAiB;CACvC,oBAAoB;;;EAGxB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB,EACc,oCAAoC,EACxC,iBAAiB,EACjB,sBAAsB,EACtB,iBAAiB;CACvC,oBAAoB;EACxB,mBAAmB;EACnB,WAAW;EACX,+BAA+B;EAC/B,qBAAqB;EACrB,mBAAmB;AACrB;AACA;IACI,OAAO,YAAY,EAAE;IACrB,OAAO,UAAU,EAAE;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,+BAA+B;EAC/B,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;EACb,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,sCAAsC;EACtC,6BAA6B;EAC7B,gCAAgC;EAChC,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,wBAAwB;AAC1B","sourcesContent":["#chat-message-list {\n  display: flex;\n  flex-direction: column-reverse;\n  overflow-y: scroll;\n  height: 60vh;\n  -ms-overflow-style: none;  /* IE and Edge */\n  scrollbar-width: none;  /* Firefox */\n}\n\n.message-row {\n  display: grid;\n  grid-template-columns: 70%;\n  margin-bottom: 10px;\n}\n\n.message-content {\n  display: grid;\n}\n\n.you-message {\n  justify-content: end;\n}\n\n.you-message .message-content {\n  justify-items: end;\n}\n\n.other-message {\n  justify-items: start;\n}\n\n.other-message .message-content {\n  /* grid-template-columns: 48px 1fr; */\n  grid-column-gap: 15px;\n}\n\n.message-row-img {\n  border-radius: 100%;\n  grid-row: span 2;\n  height: 50px;\n}\n\n.message-time {\n  font-size: 1.2vh;\n  color: #868686;\n}\n\n.message-text {\n  padding: 12px 18px;\n  font-size: 18px;\n  line-height: 25px;\n  margin-bottom: 5px;\n  max-width: 45vw;\n  font-weight: 400;\n}\n\n\n\n.you-message .new {\n  padding: 12px 18px;\n  font-size: 18px;\n  line-height: 25px;\n  margin-bottom: 5px;\n  max-width: 45vw;\n  font-weight: 400;\n  -webkit-animation: fadein 1s; /* Safari, Chrome and Opera > 12.1 */\n -moz-animation: fadein 1s; /* Firefox < 16 */\n  -ms-animation: fadein 1s; /* Internet Explorer */\n   -o-animation: fadein 1s; /* Opera < 12.1 */\n      animation: fadein 1s;\n  \n\n  transform-origin:  bottom;\n  background: #0E6495;\n  color: #E9EEF3;\n  border-radius: 16px 16px 0 16px;\n}\n\n.other-message .new {\n  padding: 12px 18px;\n  font-size: 18px;\n  line-height: 25px;\n  margin-bottom: 5px;\n  max-width: 45vw;\n  font-weight: 400;\n  -webkit-animation: fadein 1s; /* Safari, Chrome and Opera > 12.1 */\n -moz-animation: fadein 1s; /* Firefox < 16 */\n  -ms-animation: fadein 1s; /* Internet Explorer */\n   -o-animation: fadein 1s; /* Opera < 12.1 */\n      animation: fadein 1s;\n  background: #dbdbdb;\n  color: #000;\n  border-radius: 16px 16px 16px 0;\n  overflow-wrap: normal;\n  text-overflow: wrap;\n}\n@keyframes fadein {\n    from { opacity: 0.4; }\n    to   { opacity: 1; }\n}\n\n.you-message .new-img {\n  padding: 12px 18px;\n  font-size: 18px;\n  line-height: 25px;\n  margin-bottom: 5px;\n  max-width: 62vw;\n  font-weight: 400;\n  -webkit-animation: fadein 1s; /* Safari, Chrome and Opera > 12.1 */\n -moz-animation: fadein 1s; /* Firefox < 16 */\n  -ms-animation: fadein 1s; /* Internet Explorer */\n   -o-animation: fadein 1s; /* Opera < 12.1 */\n      animation: fadein 1s;\n  \n\n  transform-origin:  bottom;\n  background: #0E6495;\n  color: #E9EEF3;\n  border-radius: 16px 16px 0 16px;\n}\n\n.other-message .new-img {\n  padding: 12px 18px;\n  font-size: 18px;\n  line-height: 25px;\n  margin-bottom: 5px;\n  max-width: 62vw;\n  font-weight: 400;\n  -webkit-animation: fadein 1s; /* Safari, Chrome and Opera > 12.1 */\n -moz-animation: fadein 1s; /* Firefox < 16 */\n  -ms-animation: fadein 1s; /* Internet Explorer */\n   -o-animation: fadein 1s; /* Opera < 12.1 */\n      animation: fadein 1s;\n  background: #dbdbdb;\n  color: #000;\n  border-radius: 16px 16px 16px 0;\n  overflow-wrap: normal;\n  text-overflow: wrap;\n}\n@keyframes fadein {\n    from { opacity: 0.4; }\n    to   { opacity: 1; }\n}\n\n.you-message .message-text {\n  background: #0E6495;\n  color: #E9EEF3;\n  border-radius: 16px 16px 0 16px;\n}\n\n.other-message .message-text {\n  background: #dbdbdb;\n  color: #000;\n  border-radius: 16px 16px 16px 0;\n  overflow-wrap: normal;\n  text-overflow: wrap;\n}\n\n.customModal {\n  background: #dbdbdb;\n  max-height: 100vh;\n  max-width: 100vw;\n  margin: 0;\n  padding: 0;\n}\n\n.closeIcon {\n  fill: #eee;\n  background-color: red;\n  border-radius: 4px;\n}\n\n.message-text-parent {\n  color: #E9EEF3;\n  background: #0E6495;\n  opacity:0.8;\n  padding: 5px;\n  border-radius: 6px;\n  position: relative;\n  left: -5px;\n  width: 100%;\n  overflow-x: hidden;\n  text-overflow: ellipsis;\n  display: flex;\n  font-size: 15px;\n  margin-bottom:3px;\n}\n\n.reply-text-left{\n  background-color: aliceblue !important;\n  border-top-left-radius: 7.5px;\n  border-bottom-left-radius: 7.5px;\n  flex: none;\n  width: 100%;\n  width: 4px;\n  height: 25px;\n  margin-right: 2px;\n}\n\n.exhibitHover:hover {\n  box-shadow: 3px 3px 10px 10px rgba(0, 0, 0, 0.4);\n}\n\n.noScrollbar::-webkit-scrollbar {\n  display: none !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
